import NewReceipt from './NewReceipt';

export default NewReceipt;
